<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/p11.jpg"/><a id="page_11"></a></p><a id="page_11">
<p class="fm1"><b>Mary Jo King, NCRW Alliance Resume and Writing Service</b></p>
<p class="txc">(262) 681-5682</p>
</a><p class="txc"><a id="page_11"></a><a href="mailto:MJ@alliancewritingservice.com" id="AMm">MJ@alliancewritingservice.com</a></p>
<p class="txt1">Mary Jo has written more than 5,000 resumes for college graduates, mid-career professionals, STEM careers, and executive clientele. Her work at Alliance Resume and Writing Service is characterized by in-depth personal consultations and ongoing client support. As a former hiring authority, she is also able to offer insight to employer recruiting perspectives.</p>
<p class="tx">Her thirty-year career in professional writing began in 1982 as the Denver franchise owner of a national resume writing company. In her first year with the company, she was recruited to serve—ultimately for six years—as Regional Director of a five-state region with twenty-three offices.</p>
<p class="tx">After leaving Professional Resume Service, she enjoyed a consulting and media career working with business owners to enhance operations and develop marketing solutions. In 2010, she returned to her own resume writing practice, where she create resumes, cover letters, LinkedIn profiles, biographies, performance profiles, and other marketing tools.</p>
<p class="tx">Mary joined the National Resume Writers’ Association in 2011, where she earned the prestigious Nationally Certified Resume Writer (NCRW) credential. She is currently in her sixth year of board service for this nonprofit organization.</p>
<p class="tx">As the name of her company suggests, Mary likes to build long-term partnerships. You are the expert in your field, and she is the expert in hers. Together, she creates your compelling value proposition. Your satisfaction is both paramount and guaranteed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter12.vue?13fbae3c